import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitPayload} from '../types/commit-types'

export const commitRoute = commitsAppBuilder.createQueryRouteConfig('commitRoute', {
  path: '/:owner/:repo/commit/:oid',
  queries: [
    mainQuery<CommitPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
